import { FeatureAppDefinition } from '@feature-hub/core';
import { ReactFeatureApp } from '@feature-hub/react';
import React, { Suspense } from 'react';
import { HistoryServiceV3 } from '@feature-hub/history-service';
import { unstable_HistoryRouter as HistoryRouter } from 'react-router-dom';
import { AuthServiceProviderV2, IAuthServiceV2 } from '@volkswagen-onehub/authservice';
import { App } from './app';
import { FeatureServicesContext } from './use-feature-services';
import { Dependencies } from './dependency';
import { dummyAuthService } from './utils/DummyAuthServiceV2';

export const featureAppDefinition: FeatureAppDefinition<ReactFeatureApp, Dependencies> = {
	optionalDependencies: {
		featureServices: {
			'vw:authService': '^2.0.0',
		},
	},
	dependencies: {
		featureServices: {
			'breadcrumb-service': '^1.0.0',
			'disclaimer-manager': '^1.4.0',
			'fa-content-service': '^1.0.0',
			'layer-manager': '^2.7.1',
			'locale-service': '^1.2.0',
			's2:history': '^3.0.0',
			's2:logger': '^1.0.0',
			'tracking-service-config': '^1.0.0',
			tracking: '^1.0.0',
			'user-interaction-service': '^2.2.0',
		},
		externals: {
			'@feature-hub/react': '^2.13.1 || ^3.0.0',
			react: '^17.0.0 || ^18.0.0',
			'react-dom': '^17.0.0 || ^18.0.0',
			'styled-components': '^5.0.0',
		},
	},

	create: (env: any) => {
		const contentService = env.featureServices['fa-content-service'];
		const legalEntity: string = contentService.content?.legalEntity ? contentService.content.legalEntity : 'market';

		const localeService: any = env.featureServices['locale-service'];
		const historyService = env.featureServices['s2:history'] as HistoryServiceV3;
		const provider: AuthServiceProviderV2 = (env.featureServices['vw:authService'] as AuthServiceProviderV2) || undefined;
		const authService: IAuthServiceV2 = provider?.register(legalEntity) ?? dummyAuthService;
		const authServiceMarket: IAuthServiceV2 = provider?.register('market') ?? dummyAuthService;
		return {
			render: () => {
				return (
					<Suspense fallback>
						<FeatureServicesContext.Provider value={env.featureServices}>
							<HistoryRouter history={historyService.history}>
								<App localeService={localeService} authService={authService} authServiceMarket={authServiceMarket} />
							</HistoryRouter>
						</FeatureServicesContext.Provider>
					</Suspense>
				);
			},
		};
	},
};

export default featureAppDefinition;
